export default __webpack_public_path__ + "static/hopkins-fa6dac01829cd95b1c0dbae33380913e.jpg";